export default class {
    constructor(dataObject = null) {
        this.Id = 0;
        this.OrderNumber = '';
        this.BaseModel = '';
        this.SerialNumber = '';
        this.NSSerialTrxMapLineNumber = 0;
        this.NSSalesOrderInternalId = 0;
        this.NSInvoiceInternalId = 0;
        this.NSSerialInternalId = 0;
        this.NSItemInternalId = 0;
        this.NSSourceLastModifiedUtc = null;
        this.InsertedAtUtc = null;
        this.UpdatedAtUtc = null;
        this.IsActive = true;

        // Import data if set
        if (dataObject) {
            try {
                this.Id = dataObject.id;
                this.OrderNumber = dataObject.OrderNumber;
                this.BaseModel = dataObject.BaseModel;
                this.SerialNumber = dataObject.SerialNumber;
                this.NSSerialTrxMapLineNumber =
                    dataObject.NSSerialTrxMapLineNumber ?? 0;
                this.NSSalesOrderInternalId =
                    dataObject.NSSalesOrderInternalId ?? 0;
                this.NSInvoiceInternalId = dataObject.NSInvoiceInternalId ?? 0;
                this.NSSerialInternalId = dataObject.NSSerialInternalId ?? 0;
                this.NSItemInternalId = dataObject.NSItemInternalId ?? 0;
                this.NSSourceLastModifiedUtc =
                    dataObject.NSSourceLastModifiedUtc ?? null;
                this.InsertedAtUtc = dataObject.InsertedAtUtc ?? null;
                this.UpdatedAtUtc = dataObject.UpdatedAtUtc ?? null;
                this.IsActive = dataObject.IsActive ?? true;
            } catch (e) {
                throw 'Data import error @ OrderSerialMaster data.';
            }
        }
    }
}
